<template>
  <div class="success">
    <z-stance
      type="message"
      :show-info="false"
      :descText="info"
      img-src="https://pic4.zhuanstatic.com/zhuanzh/f9436be4-ddfb-4f7b-8047-f0ae914e714c.png"
    />
  </div>
</template>

<script>
import { Stance } from '@zz-common/zz-ui'

export default {
  name: 'QualitySuccess',
  props: ['status'],
  data() {
    return {
      statusDesc: {
        deal: '提交成功，请耐心等待工作人员审核',
        over: '恭喜您提交的资质审核通过，您可以发布许可经营范围内的商品啦',
        process: '您提交的资质正在审核中'
      }
    }
  },
  computed: {
    info() {
      return this.statusDesc[this.status]
    }
  },
  components: {
    zStance: Stance
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
